import useMutationCall from "../../../hooks/useMutationCall";
import { useAddClientMutation } from "../clientsSlice";

const useClientPatch = () => {
  return useMutationCall(useAddClientMutation);
};

export default useClientPatch;
